/**
 * Date Picker Section Component
 * Handles rendering of date picker sections for both edit and display modes
 */

import React, { useRef } from "react";
import moment from "moment";
import { DatePicker } from "rsuite";
import { CalendarIcon } from "./SvgIcons.jsx";
import { CSS_CLASSES, DEFAULT_VALUES, INLINE_STYLES } from "../utils/cardBodyConstants.js";
import { isEntryUnlocked } from "../utils/cardBodyDateHelpers.js";

/**
 * Date Picker Section for Edit Mode
 */
export const EditDatePickerSection = ({
  dateEdit,
  setDateEdit,
  setDateOldEdit,
  datePickerRef,
  handleDateIconClick,
  appSettings,
  getLockHoursHandler,
  onClick,
  className = "",
}) => {
  const localContainerRef = useRef(null);

  return (
    <div
      ref={localContainerRef}
      className={`${CSS_CLASSES.DATE_OVERVIEW_SEC} ${CSS_CLASSES.DATE_OVERVIEW_EDIT} ${className}`}
      onClick={onClick}
    >
      <div onClick={handleDateIconClick} className={CSS_CLASSES.CUSTOM_DATE_ICON}>
        <CalendarIcon />
      </div>
      <DatePicker
        block
        name="date"
        appearance="subtle"
        value={moment(dateEdit, "YYYY-MM-DD HH:mm:ss").toDate()}
        onChange={(value) => {
          setDateOldEdit(moment(dateEdit, "YYYY-MM-DD HH:mm:ss").toDate());
          setDateEdit(value);
        }}
        ref={datePickerRef}
        container={() =>
          localContainerRef.current?.closest(".timetracker-inner.data-time-tracker") ||
          localContainerRef.current?.closest(".timetracker-inner") ||
          localContainerRef.current?.closest(".timer-entry-row") ||
          localContainerRef.current ||
          document.body
        }
        placement="bottomEnd"
        oneTap
        isoWeek={
          appSettings.weekStartDay &&
          appSettings.weekStartDay === DEFAULT_VALUES.WEEK_START_MONDAY
        }
        shouldDisableDate={(date) => {
          const formattedDate = moment(date)
            .tz(global.config.getTimeZone())
            .format("YYYY-MM-DD HH:mm:ss");
          return !isEntryUnlocked(formattedDate, global.config, getLockHoursHandler);
        }}
      />
    </div>
  );
};

/**
 * Date Picker Section for Display Mode
 */
export const DisplayDatePickerSection = ({
  onClick,
  className = "",
}) => {
  return (
    <div className={`${CSS_CLASSES.DATE_OVERVIEW_SEC} ${className}`} onClick={onClick}>
      <div className={CSS_CLASSES.CUSTOM_DATE_ICON} style={INLINE_STYLES.CURSOR_POINTER}>
        <CalendarIcon />
      </div>
    </div>
  );
};
